import { render } from "./BiotronManualDiagnostics.vue?vue&type=template&id=f514613c&scoped=true"
import script from "./BiotronManualDiagnostics.vue?vue&type=script&lang=js"
export * from "./BiotronManualDiagnostics.vue?vue&type=script&lang=js"

import "./BiotronManualDiagnostics.vue?vue&type=style&index=0&id=f514613c&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f514613c"]])

export default __exports__